import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { SingleProductCollapsibleWriteReviewForm } from "../apps/reviews/SingleProductCollapsibleWriteReviewForm";
import { setProductTypes } from "../apps/reviews/reducers";
import { IReviewsProductTypeID, isoFormUUID } from "../models/nominals";
import { useAppSelector, useSSRStorePrefill } from "../store/reducers";

type IProps = Immutable<templates.WriteReviewButtonTemplate>;

export const Template = (props: IProps): React.JSX.Element => {
    const formUUID = isoFormUUID.wrap(React.useId());
    const productTypeIDs = useAppSelector(
        (state) => state.reviews.ui.productTypeIDs,
    );
    const displayedProductTypeIDWhitelist: readonly IReviewsProductTypeID[] =
        React.useMemo<readonly IReviewsProductTypeID[]>(() => {
            try {
                const parsed: unknown = JSON.parse(
                    props.product_type_whitelist || "[]",
                );
                if (!Array.isArray(parsed)) return [];
                return parsed.filter(
                    (v): v is IReviewsProductTypeID => typeof v === "number",
                );
            } catch {
                return [];
            }
        }, [props.product_type_whitelist]);

    // Only pass stable props to useSSRStorePrefill to avoid re-running on
    // productTypeIDs changes (which our own dispatch triggers). The closure
    // captures productTypeIDs from the initial render — sufficient for
    // one-time SSR/mount initialization.
    useSSRStorePrefill(
        { displayedProductTypeIDWhitelist },
        (dispatch, data) => {
            if (data.displayedProductTypeIDWhitelist.length === 0) return;
            const selectedProductTypeIDs = productTypeIDs.filter((tid) =>
                data.displayedProductTypeIDWhitelist.includes(tid),
            );
            const desired: readonly IReviewsProductTypeID[] =
                selectedProductTypeIDs.length > 0
                    ? selectedProductTypeIDs
                    : [data.displayedProductTypeIDWhitelist[0]];
            dispatch(setProductTypes(desired));
        },
    );

    return (
        <SingleProductCollapsibleWriteReviewForm
            formUUID={formUUID}
            brand={props.brand || undefined}
            displayedProductTypeIDWhitelist={displayedProductTypeIDWhitelist}
        />
    );
};
